import React, { Component } from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import isEqual from 'lodash/isEqual';

export default class HierarchyDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = { data: props.data };
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.data, this.state.data)) {
      this.setState({ data: nextProps.data });
    }
  }

  shouldComponentUpdate(nextProps) {
    return (
      !isEqual(nextProps.data, this.state.data) ||
      nextProps.disabled !== this.props.disabled
    );
  }

  render() {
    const { data, disabled, ...rest } = this.props;

    return (
      <div
        style={{
          color: disabled ? '#6c759d' : '',
          opacity: disabled ? 0.6 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
          borderRadius: '4px',
        }}
      >
        <style>{`
          .react-dropdown-tree-select .node {
            display: inline-flex !important;
            align-items: center !important;
            flex-direction: row !important;
            flex-wrap: nowrap !important;
            width: 100%;
            gap: 4px;
          }
          .react-dropdown-tree-select .toggle {
            display: inline !important;
            vertical-align: middle;
            margin-right: 2px;
            cursor: pointer;
          }
          .react-dropdown-tree-select label {
            display: inline !important;
            margin: 0 !important;
            vertical-align: middle;
            cursor: pointer;
          }
          .react-dropdown-tree-select .checkbox-item {
            display: inline-flex !important;
            align-items: center;
            margin: 0 !important;
          }
          .react-dropdown-tree-select ul {
            padding-left: 16px;
            margin: 0;
          }
          .react-dropdown-tree-select li {
            list-style: none;
          }
        `}</style>
        <DropdownTreeSelect data={this.state.data} {...rest} />
      </div>
    );
  }
}